import { ButtonIntent } from '@core/components/Button';
import React, { CSSProperties, memo, ReactNode } from 'react';
import { Badge } from 'reactstrap';

export interface InfoBannerProps {
  icon?: string;
  prefix?: string | ReactNode;
  children: string | ReactNode;
  intent?: ButtonIntent;
  style?: CSSProperties;
  className?: string;
  onClick?(): void;
}

export const InfoBanner = memo((props: InfoBannerProps) => {
  const { intent = 'info' } = props;
  return (
    <Badge
      className={`badge-soft-${intent} p-2 font-size-12 text-left d-flex align-items-center ${props.className || ''} mb-4 `}
      style={{ whiteSpace: 'normal', lineHeight: 1.5, ...(props.style || {}) }}
      onClick={props.onClick}
    >
      <i className={`fa ${props?.icon || 'fa-exclamation-circle'} mr-2 font-size-16`}></i>
      {props.children}
    </Badge>
  );
});
